var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-page"},[_c('nav-bar'),_c('project-list'),_c('site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }